import { EuroOutlined } from '@ant-design/icons';
import { TableAction } from 'components/ui/TableAction';
import {
  usePayTooltipProps,
  usePayIconClassName,
  usePayActionModal,
} from 'hooks/invoiceSearchActions/pay';
import { useInvoiceActionsFlags } from 'hooks/invoiceSearchActions/useInvoiceActionsFlags';

export const PayInvoiceAction = () => {
  const { canPay } = useInvoiceActionsFlags();

  const tooltipProps = usePayTooltipProps();
  const iconStyle = usePayIconClassName();
  const handleShowModal = usePayActionModal();

  if (!canPay) {
    return null;
  }

  return (
    <TableAction
      tooltipProps={tooltipProps}
      displayComponent={
        <EuroOutlined className={iconStyle} onClick={handleShowModal} />
      }
    />
  );
};
